import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  addPersonsTabs: {
    '.ant-tabs-nav': { margin: 0 },
    '.ant-tabs-nav::before': {
      borderBottom: 'none !important'
    }
  },
  text: {
    fontSize: '20px !important',
    fontWeight: '700'
  },
  idnpSearch: {
    maxWidth: '428px',
    width: '100%'
  },

  personsCard: {
    '.ant-card-body': { padding: 0 },
    width: '100%'
  }
}))
